import moment from "moment";
import { GDPRConsentRecordsDataFragment, GDPRConsentType } from "@bonliva-crm/graphql";
import locale, { dateFormat } from "@bonliva-crm/locale";

export type ConsentState = "granted" | "revoked" | "unknown";

/**
 * Resolves the display state of a single Behovsutskick sub-consent. A missing
 * record renders as `unknown` (not `revoked`), per CRMDEV-6459.
 */
export const resolveConsentState = (
  consent?: GDPRConsentRecordsDataFragment | null
): ConsentState => {
  if (!consent) {
    return "unknown";
  }

  return consent.granted ? "granted" : "revoked";
};

/** Tooltip text describing who granted/revoked the consent and when. */
export const buildConsentTooltip = (
  consent?: GDPRConsentRecordsDataFragment | null
): string => {
  if (!consent) {
    return locale.notSpecified;
  }

  if (consent.granted) {
    const name = consent.grantedBy?.Name ?? "-";
    const date = consent.dateGranted
      ? moment(consent.dateGranted).format(dateFormat)
      : "-";

    return `${locale.Granted} • ${name} • ${date}`;
  }

  const name = consent.revokedBy?.Name ?? "-";
  const date = consent.dateRevoked ? moment(consent.dateRevoked).format(dateFormat) : "-";

  return `${locale.NotGranted} • ${name} • ${date}`;
};

/** Picks the sub-consent record for a given JobMailing channel. */
export const findJobMailingConsent = (
  records: GDPRConsentRecordsDataFragment[] | undefined | null,
  type: GDPRConsentType.JobMailingEmail | GDPRConsentType.JobMailingSms
): GDPRConsentRecordsDataFragment | undefined => {
  return (records ?? []).find((record) => record.type === type);
};
